module.exports = __webpack_public_path__ + "8ba9c0c325e87c109bb4b1ff6ecf5461.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/team_philip_mobile.jpg
// module id = 673
// module chunks = 0